<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Price')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Price')"
                vid="price"
                rules="required"
              >
                <b-form-input
                  id="price"
                  v-model="form.price"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Price')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Limit per day')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Limit per day')"
                vid="limit_per_day"
                rules="required"
              >
                <b-form-input
                  id="limit_per_day"
                  v-model="form.limit_per_day"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Limit per day')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Number of accounts')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Number of accounts')"
                vid="number_of_accounts"
                rules="required"
              >
                <b-form-input
                  id="limit_per_day"
                  v-model="form.number_of_accounts"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Number of accounts')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Webhook')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Webhook')"
                vid="webhook"
                rules="required"
              >
                <b-form-input
                  id="webhook"
                  v-model="form.webhook"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Webhook')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Messages count')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Messages count')"
                vid="messages_count"
                rules="required"
              >
                <b-form-input
                  id="messages_count"
                  v-model="form.messages_count"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Messages count')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Extra accounts')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Extra accounts')"
                vid="extra_accounts"
                rules="required"
              >
                <b-form-input
                  id="extra_messages"
                  v-model="form.extra_accounts"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Extra accounts')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Icon')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Icon')"
                vid="icon"
                rules="required"
              >
                <b-form-input
                  id="icon"
                  v-model="form.icon"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Icon')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group
              :label="$t('Description')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Description')"
                vid="description"
                rules="required"
              >
                <b-form-textarea
                  id="description"
                  v-model="form.description"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Description')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'PanelsEditModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'panels',
      modalName: 'modal-panels-edit',
      createAbleFields: [
        'name',
        'price',
        'messages_count',
        'limit_per_day',
        'webhook',
        'number_of_accounts',
        'extra_accounts',
        'icon',
        'description',
      ],
    }
  },
}
</script>

<style scoped>

</style>
